import {Component, OnInit} from '@angular/core';
import {ButtonMeta} from '../../common/buttons/buttonMeta';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {ModalWindowComponent} from '../../common/modal-window/modal-window';
import {ServiceAnswer} from '../../../../shared/service-answer';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ApplicationCacheService} from '../../../services/application-cache.service';
import {MessageService} from '../../../../shared/message.service';
import {BaseComponent} from '../../general/base/base.component';

@Component({
  selector: 'app-tools',
  templateUrl: 'tools.component.html',
  styleUrls: ['tools.component.css']
})
export class ToolsComponent extends BaseComponent implements OnInit {

  private static CONTROL_BUTTON_DELETE_APPLICATION_CACHE = 'CONTROL_BUTTON_DELETE_APPLICATION_CACHE';

  constructor(
    private applicationCacheService: ApplicationCacheService,
    private modalService: NgbModal,
    private messagesService: MessageService,
  ) {
    super();
  }

  ngOnInit(): void {
  }

  /**
   * When a control button has been pressed.
   * @param buttonId The id of the button.
   */
  controlButtonPressed(buttonId: string) {
    if (buttonId === ToolsComponent.CONTROL_BUTTON_DELETE_APPLICATION_CACHE) {
      this.openApplicationCacheDeleteDialog();
    }
  }

  /**
   * Opens a dialog that asks
   */
  public openApplicationCacheDeleteDialog(): void {

    const ngbModalRef: NgbModalRef = this.modalService.open(ModalWindowComponent);
    this.increaseOpenView();
    ngbModalRef.componentInstance.title = `Delete the application cache?`;
    ngbModalRef.componentInstance.text = `Are you sure that you want to delete the application cache?`;

    ngbModalRef.componentInstance.buttons = [
      {text: 'Cancel', id: 'cancel', focus: true},
      {text: 'Delete', id: 'delete'},
    ];
    ngbModalRef.componentInstance.closed = async (buttonId: string) => {
      ngbModalRef.close();
      if (buttonId === 'delete') {
        try {
          const serviceAnswer: ServiceAnswer<any> = await this.applicationCacheService.removeApplicationCache();
          // console.log(JSON.stringify(serviceAnswer));
          if (serviceAnswer.isOk) {
            this.messagesService.addSuccess(`Successfully deleted the application cache`);
            return;
          } else {
            const errorMessage = `Deleting the application cache failed. Backend returned HTTP code ${serviceAnswer.errorCode}. \
            Error message: ${serviceAnswer.errorMessage}`;
            console.error(errorMessage);
            this.messagesService.addDanger(errorMessage);
          }
        } catch (error) {
          const message = `Unexpected error when deleting the application cache: ${JSON.stringify(error)}`;
          console.error(message);
          this.messagesService.addDanger(message);
        }
      }
    };

    ngbModalRef.result.then((result) => {
      this.decreaseOpenView();
    }, (reason) => {
      this.decreaseOpenView();
    });
  }


  /**
   * Returns array of button meta objects. These objects are used to create buttons.
   */
  public getButtonsMeta(): ButtonMeta[] {
    return [
      {
        id: ToolsComponent.CONTROL_BUTTON_DELETE_APPLICATION_CACHE,
        text: 'Delete application cache',
        type: 'general',
        disableWhenNoSelection: false
      }
    ];
  }

}
